import { createContext } from 'react';

const FormSubmitContext = createContext({});

export default FormSubmitContext;
